import { KnownAction } from "../actions/subscriptions.actions";
import { ISubscriptionsState } from "../models/subscriptions.interface";

const initialState: ISubscriptionsState = {
  documents: {},
};

function subscriptionsReducer(
  state: ISubscriptionsState = initialState,
  action: KnownAction
): ISubscriptionsState {
  switch (action.type) {
    case "REQUEST_SUBSCRIPTIONS": {
      return {
        ...state,
        items: "loading",
      };
    }
    case "SET_SUBSCRIPTIONS": {
      return {
        ...state,
        items: action.data,
      };
    }
    case "SET_SUBSCRIPTIONS_ERROR": {
      return {
        ...state,
        items: "error",
      };
    }
    case "REQUEST_DOCUMENTS": {
      return {
        ...state,
        documents: {
          ...state.documents,
          [action.subscription]: "loading",
        },
      };
    }
    case "SET_DOCUMENTS": {
      return {
        ...state,
        documents: {
          ...state.documents,
          [action.subscription]: {
            items: action.items,
            expires: action.expires,
          },
        },
      };
    }
    case "SET_DOCUMENTS_ERROR": {
      return {
        ...state,
        documents: {
          ...state.documents,
          [action.subscription]: "error",
        },
      };
    }
    default:
      return state;
  }
}

export default subscriptionsReducer;
